import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ICourse } from '../models/courses.model';
import { CourseService } from '../courses.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { AspectType, CropperComponentModal, ResolutionType, CloudStorageData } from '@dataclouder/ngx-cloud-storage';

import { TOAST_ALERTS_TOKEN, ToastAlertsAbstractService } from '@dataclouder/ngx-core';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { DialogModule } from 'primeng/dialog';
import { CourseListComponent } from '../course-list/course-list.component';

@Component({
  selector: 'app-source-form',
  imports: [
    ReactiveFormsModule,
    CardModule,
    TextareaModule,
    DropdownModule,
    ButtonModule,
    SelectModule,
    InputTextModule,
    ChipModule,
    TooltipModule,
    CropperComponentModal,
    FormlyModule,
    DialogModule,
    CourseListComponent,
  ],
  templateUrl: './course-form.component.html',
  styleUrl: './course-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CourseFormComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private courseService = inject(CourseService);
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private toastService = inject<ToastAlertsAbstractService>(TOAST_ALERTS_TOKEN);
  private cdr = inject(ChangeDetectorRef);

  public storageImgSettings = {
    path: `courses`,
    cropSettings: { aspectRatio: AspectType.Square, resolutions: [ResolutionType.MediumLarge], resizeToWidth: 700 },
  };

  extraFields: FormlyFieldConfig[] = [
    { key: 'title', type: 'input', props: { label: 'Title', placeholder: 'Title', required: false } },
    { key: 'content', type: 'textarea', props: { label: 'Content', placeholder: 'Content', required: false } },
  ];

  public courseForm = this.fb.group({
    name: ['', Validators.required],
    description: [''],
    image: [{} as CloudStorageData],
  });

  public course: ICourse | null = null;
  public courseId = this.route.snapshot.params['id'];

  async ngOnInit(): Promise<void> {
    if (this.courseId) {
      this.course = await this.courseService.getCourse(this.courseId);
      if (this.course) {
        this.courseForm.patchValue(this.course);
      }
    }
  }

  async save() {
    if (this.courseForm.valid) {
      const course = { ...this.course, ...this.courseForm.value } as ICourse;

      const result = await this.courseService.saveCourse(course);

      if (!this.courseId) {
        this.router.navigate([result.id], { relativeTo: this.route });
      }
      this.toastService.success({ title: 'Origen guardado', subtitle: 'El origen ha sido guardado correctamente' });
    }
  }

  public handleImageUpload(event: any) {
    // this.genericForm.patchValue({ image: event });
    alert('Image uploaded');
  }
}
